var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('p',{staticClass:"text-h1"},[_vm._v("Here is home")])])
}
var staticRenderFns = []

export { render, staticRenderFns }